const paperOverrides = {
  styleOverrides: {
    root: {
      borderRadius: 0,
    },
  },
};

export default paperOverrides;
